import Software from './abstract/Software';

/*
 * Model class Download
 */
export default class Download extends Software {
	constructor($sce, $content, $deviceDisplayCount = 2) {
        super($sce, $content, $deviceDisplayCount);

		this.$sce = $sce;
		this.content = $content;
		this.mobileProtected = $sce.trustAsHtml('<svg><use xlink:href="#mobile-protected" class="screen" /></svg>');
		this.mobileUnProtected = $sce.trustAsHtml('<svg><use xlink:href="#mobile-unprotected" class="screen" /></svg>');
	}

	getInstallCount(device) {
		return new Promise((resolve, reject)=> {
			$.get('/user/get-odp-install-count/'+ device, function(data){
				resolve(data);
			});
		});
	}

	getInstallCountForPcAndMac(devices) {
		return new Promise((resolve, reject)=> {
			let installedCounts = { dpsCount: 0 };

            $.get(`/user/get-odp-install-count/${devices[0]}`, function(data){
                installedCounts.dpsCount += data.dpsCount;

                if (devices.length > 1) {
                    $.get(`/user/get-odp-install-count/${devices[1]}`, function(data){
                        installedCounts.dpsCount += data.dpsCount;

                        resolve(installedCounts);
                    });
                } else {
                    resolve(installedCounts);
                }
            });
		});
	}

	getDownloadData(device) {
		var text = "";

		switch (device) {
			case 'pc':
				text = `<h4>About Data Protection Suite</h4>
						<p>The PC and Laptop Secure Browser you can browse the internet securely and protect yoursel from the threats associated with keylogging,
						screen capture and phishing every time you enter data online</p>
						<p>For more information on how the Onlien Protection Software works please goto the FAQs section.</p>`;
			break;

			case 'mobile':
				text = `<h4>Mobile Security Suite</h4
						<p>Google powered secure browser protects you from any threat to the data you input on the web and will warn you away from fraudulent
						websites trying to steal your personal information.</p>
						<p>To download and register the Smartphone Protection SOftware to your device, follow these steps
							<ul>
								<li>If you are on your mobile or tablet device:<p>Click ont he relevent App Store logo for youe device at the bottom to go directly to the App page</p></li>
								<li>Download the App. Once installed, open the appplication on your device and complete the registration process. You will need your membership
								number (which you can find in your account profile from the dashboard when you are logged into the website) and your date of birth.</li>
							</ul>
						</p>`;
			break;
		}

		return text;
	}
}
